import {forwardRef, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import HeroBasic, {
  heroBasicBottomSpaceSizes,
  heroBasicOverlayColors,
  heroBasicPanelRounded,
  heroBasicSizes
} from '@adv-mt/mt-hero-basic'

import FormPlate from './FormPlate.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-HeroForm'

const InstantOfferLandingHeroForm = forwardRef(({onGetVehicles, sellerVehicle}, ref) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')

  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const isMobile = config.get('isMobile')

  const heroBasicProps = {
    fitToFullWidthLayout: true,
    imageSrc: `${URL_STATICS_IMAGES}coches/instant-offer/instant-offer-deal-${isMobile ? `mobile` : `desktop`}.jpg`,
    overlayColor: heroBasicOverlayColors.primary,
    panelRounded: heroBasicPanelRounded.NONE,
    rightContent: true,
    size: heroBasicSizes.s,
    withFullContrast: true,
    title: {
      children: (
        <div className={`${BASE_CLASS_NAME}Title`}>
          <h1 className={`${BASE_CLASS_NAME}TitleText`}>{'Vende tu vehículo a un profesional, sin preocupaciones'}</h1>
          <p className={`${BASE_CLASS_NAME}TitleDescription`}>
            {
              'Recibirás una tasación inicial por tu vehículo y, una vez verificado su estado por parte del profesional, obtendrás una tasación final para cerrar la venta.'
            }
          </p>
        </div>
      )
    }
  }

  return isMobile ? (
    <div className={`${BASE_CLASS_NAME}`}>
      <HeroBasic {...heroBasicProps} bottomSpaceSize={heroBasicBottomSpaceSizes.xl} />
      <div ref={ref} className={`${BASE_CLASS_NAME}ContainerWrapper ${BASE_CLASS_NAME}ContainerWrapper--mobile`}>
        <div className={`${BASE_CLASS_NAME}Container ${BASE_CLASS_NAME}Container--mobile`}>
          <FormPlate onGetVehicles={onGetVehicles} />
        </div>
      </div>
    </div>
  ) : (
    <div className={`${BASE_CLASS_NAME}`}>
      <HeroBasic {...heroBasicProps}>
        <div ref={ref} className={`${BASE_CLASS_NAME}ContainerWrapper`}>
          <div className={`${BASE_CLASS_NAME}Container`}>
            <FormPlate onGetVehicles={onGetVehicles} sellerVehicle={sellerVehicle} />
          </div>
        </div>
      </HeroBasic>
    </div>
  )
})

InstantOfferLandingHeroForm.displayName = 'InstantOfferLandingHeroForm'

InstantOfferLandingHeroForm.propTypes = {
  onGetVehicles: PropTypes.func.isRequired,
  sellerVehicle: PropTypes.shape({km: PropTypes.string.isRequired, plate: PropTypes.string.isRequired}).isRequired
}

export default InstantOfferLandingHeroForm
